import { createNavigation } from 'next-intl/navigation';

import { Routing } from './config';
import { routing } from './routing';

export const createI18nNavigation = (
  routing: Routing
): ReturnType<typeof createNavigation> => {
  return createNavigation(routing);
};

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing) as ReturnType<typeof createNavigation>;
